"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _core = require("@material-ui/core");

var _avatar = _interopRequireDefault(require("./avatar.png"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  border: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledAvatar = (0, _styledComponents.default)(function (_ref) {
  var hasState = _ref.hasState,
      props = _objectWithoutProperties(_ref, ["hasState"]);

  return _react.default.createElement(_core.Avatar, props);
})(_templateObject(), function (props) {
  switch (props.size) {
    case 'xs':
      return '40px';

    case 'small':
      return '48px';

    case 'medium':
      return '56px';

    case 'large':
      return '68px';

    default:
      return '48px';
  }
}, function (props) {
  switch (props.size) {
    case 'xs':
      return '40px';

    case 'small':
      return '48px';

    case 'medium':
      return '56px';

    case 'large':
      return '68px';

    default:
      return '48px';
  }
}, function (props) {
  return props.hasState ? "3px solid ".concat(props.theme.palette[props.color].main) : 'none';
});

var Avatar = function Avatar(_ref2) {
  var src = _ref2.src,
      props = _objectWithoutProperties(_ref2, ["src"]);

  return _react.default.createElement(StyledAvatar, Object.assign({
    src: src || _avatar.default
  }, props));
};

Avatar.defaultProps = {
  src: _avatar.default,
  size: 'xs',
  hasState: false,
  color: 'error'
};
var _default = Avatar;
exports.default = _default;